import { Store } from "@reduxjs/toolkit";
import { useEffect } from "react";
import { RESET_STATE_ACTION_TYPE } from "./constants";

/**
 * Хук для сброса состояния redux
 *
 * @example
 * export const Routes = () => {
 *  useResetState(store);
 *
 *  return (
 *    <Provider store={store}
 *      <MyRootComponent />
 *    </Provider>
 *  );
 * }
 */

export const useResetState = (store: Store) => {
  useEffect(
    () => () => {
      store.dispatch({ type: RESET_STATE_ACTION_TYPE });
    },
    [store]
  );
};
